// extracted by mini-css-extract-plugin
export default {"bettingGridCell":"ez_eA"};